import { render, staticRenderFns } from "./cartao-frente.vue?vue&type=template&id=a041f3a8&scoped=true"
import script from "./cartao-frente.vue?vue&type=script&lang=js"
export * from "./cartao-frente.vue?vue&type=script&lang=js"
import style0 from "./cartao-frente.vue?vue&type=style&index=0&id=a041f3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a041f3a8",
  null
  
)

export default component.exports